import { MapType } from '@/types';

export enum ORDER_STATUSES {
  CREATED = 'CREATED',
  CONFIRMED = 'CONFIRMED',
  FAILED = 'FAILED',
  READY_TO_BE_SHIPPED = 'READY_TO_BE_SHIPPED',
  SHIPPED = 'SHIPPED',
  DELIVERED = 'DELIVERED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  REFUND_INITIATED = 'REFUND_INITIATED',
  IN_PROCESS = 'IN_PROCESS',
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  RETURNED = 'RETURNED',
  REFUNDED = 'REFUNDED',
  ON_HOLD = 'ON_HOLD',
  PARTIALLY_SHIPPED = 'PARTIALLY_SHIPPED',
  BACKORDERED = 'BACKORDERED',
  PICKED_UP = 'PICKED_UP',
  PICKUP_REJECTED = 'PICKUP_REJECTED',
  CANCELLATION_INITIATED = 'CANCELLATION_INITIATED',
  RETURN_INITIATED = 'RETURN_INITIATED',
  PICKUP_SCHEDULED = 'PICKUP_SCHEDULED',
}
export const STATUS_LABEL_MAP: MapType = {
  [ORDER_STATUSES.CREATED]: 'Payment pending',
  [ORDER_STATUSES.FAILED]: 'Payment failed',
  [ORDER_STATUSES.CONFIRMED]: 'Arriving on ',
  [ORDER_STATUSES.READY_TO_BE_SHIPPED]: 'Arriving on ',
  [ORDER_STATUSES.SHIPPED]: 'Arriving on ',
  [ORDER_STATUSES.DELIVERED]: 'Delivered on ',
  [ORDER_STATUSES.CANCELLED]: 'Cancelled on ',
  [ORDER_STATUSES.COMPLETED]: 'Completed on ',
};

export const STATUS_DATE_KEY_MAP: MapType = {
  [ORDER_STATUSES.CONFIRMED]: 'etd',
  [ORDER_STATUSES.READY_TO_BE_SHIPPED]: 'etd',
  [ORDER_STATUSES.SHIPPED]: 'etd',
  [ORDER_STATUSES.DELIVERED]: 'deliveredOn',
  [ORDER_STATUSES.CANCELLED]: 'cancelledOn',
  [ORDER_STATUSES.COMPLETED]: 'deliveredOn',
};

export enum DISCOUNT_TYPES {
  PREXO = 'PREXO',
  COUPON = 'COUPON',
  SHIPPING = 'SHIPPING',
  INSTALLATION = 'INSTALLATION',
  BANK_DISCOUNT = 'BANK_DISCOUNT',
}

export const DISCOUNT_LABELS: MapType = {
  [DISCOUNT_TYPES.PREXO]: 'Exchange applied',
  [DISCOUNT_TYPES.COUPON]: '{COUPON} applied',
  [DISCOUNT_TYPES.SHIPPING]: 'Shipping worth {amount}',
  [DISCOUNT_TYPES.INSTALLATION]: 'Installation worth {amount}',
  [DISCOUNT_TYPES.BANK_DISCOUNT]: 'Bank Discount',
  // Add other discount labels if needed
};

export enum ORDER_STATUS {
  ORDER_RECEIVED = 'Order Received',
  READY_TO_BE_SHIPPED = 'Ready to be Shipped',
  ORDER_IN_TRANSIT = 'Order In Transit',
  OUT_FOR_DELIVERY = 'Out for Delivery',
  ORDER_DELIVERED = 'Order Delivered',
  PICKUP_SCHEDULED = 'Pickup Scheduled',
}
